module.exports = __webpack_public_path__ + "static/scale-model-of-broken-arrow-museum-in-broken-arrow-oklahoma-7eb47c4d1dad66faa68a760008cc1ce4.png";